import React from 'react';
import { Flex } from '@mutiny-pkg/dumpster-ui/components/Flex';
import { Tooltip } from '@mutiny-pkg/dumpster-ui/components/Tooltip';
import { Typography } from '@mutiny-pkg/dumpster-ui/components/Typography';

export const FloatingMenuTooltip = ({
  title,
  keyboardShortcut,
  children,
}: {
  title: string;
  keyboardShortcut?: string;
  children: React.ReactNode;
}) => {
  return (
    <Tooltip
      content={
        <Flex.Container flexDirection="column" alignItems="flex-start" padding="none">
          <Typography font="caption1">{title}</Typography>
          {keyboardShortcut && <Typography font="caption2">{keyboardShortcut}</Typography>}
        </Flex.Container>
      }
      side="top"
      align="center"
      padding="small"
      variant="dark"
      delayDuration={2000}
      asChild
    >
      {children}
    </Tooltip>
  );
};
